import { Request } from '@/utils';
import { UserType } from '@/types';

class User extends Request {
	getUserInfo() {
		return this.userGet<UserType>({
			url: '/mobile/getInfo',
		});
	}
}

export const UserApi = new User();
